// Colours for BST variants (BST, BSTrec, AVL)
// Moving to new color scheme
// (XXX may be leftovers from older scheme)
// We use the color names directly rather than the trivial mapping here:
// import {ALGO_COLOR_PALLETE} from '../../components/DataStructures/colors';

export const BSTColors = {
    // Insert stuff
    // (ALSO USED FOR RECURSIVE SEARCH)
    // P_N: ALGO_COLOR_PALLETE.peach, // newly inserted node
    P_N: "var(--peach)", // node P (BST)
    PATH_N: "var(--peach)", // path node (BST)
    PATH_E: "var(--peach)", // path edges (BST)
    NEW_N: "var(--leaf)", // newly inserted node
    ROT_E: "var(--apple)", // rotated edge (AVL)
    ROT_N: "var(--apple)", // rotated nodes (AVL)
    // Search stuff
    SPATH_N: "var(--peach)", // best = insert version
    SPATH_E: "var(--peach)", // best = insert version
    FOUND_N: "var(--leaf)",
    FOUND_E: "var(--leaf)",
    NOT_EQ_N: "var(--apple)",
}
